import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';

/**
 * @typedef {{
 *  id: string,
 *  value: string,
 *  name: string,
 *  labelProps?: HTMLLabelElement,
 *  vertical?: boolean,
 *  className?: any,
 * } & import('final-form').FieldConfig} RadioProps
 */

/** @type {React.FC<RadioProps>} */
const Radio = ({ id, value, name, labelProps, vertical, className, children, ...rest }) => {
  const key = id ?? value;

  return (
    <Field name={name} type="radio" value={value} {...rest}>
      {({ input }) => (
        <>
          <input id={key} className={classNames(className, { left: !vertical })} {...input} />
          <label htmlFor={key} {...labelProps}>
            {children}
          </label>
        </>
      )}
    </Field>
  );
};

export default Radio;
